import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { debounceTime, fromEvent, Subject, takeUntil } from 'rxjs';
import { SettingSelectors } from './store/setting/setting.selectors';
import { SetWebView } from './store/setting/setting.classes';
import { guidGenerator } from './shared/common/utils';
import { StorageEnum } from './shared/enum/storage';
import { Router } from '@angular/router';
import { AuthSelectors } from './store/auth/auth.selectors';
import { Logout, SetToken } from './store/auth/auth.classes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  private onDestory$: Subject<void>;
  private observer!: MutationObserver;
  public scrollLock: number = -1;

  constructor(private store: Store, private elRef: ElementRef, private actions: Actions, private router: Router) {
    this.onDestory$ = new Subject();
    this.actions.pipe(
      ofActionDispatched(SetWebView),
      takeUntil(this.onDestory$)
    ).subscribe(() => {
      this.registTabId();
      const isWebView = this.store.selectSnapshot(SettingSelectors.isWebView);
      if (!isWebView) return;
      this.webViewInit();
    })
  }

  ngAfterViewInit(): void {
    this.observer = new MutationObserver(mutations => {

      // if(excludeCondtion) return;
      let findClass = '.app-modal, .app-modal-spinner';
      const excludeCondtion = mutations.some(x => this.modalSearchCondition(x.addedNodes, '.no-lock'));
      const modalAttached = mutations.some(x => this.modalSearchCondition(x.addedNodes, findClass));
      const modalDetached = mutations.some(x => this.modalSearchCondition(x.removedNodes, findClass));
      if (modalAttached && excludeCondtion) {
        document.body.classList.remove('lock'); return;
      }
      if (modalAttached) {
        this.scrollLock = document.body.scrollHeight;
        document.body.classList.add('lock');
        return;
      }

      if (modalDetached) {
        document.body.classList.remove('lock');
        document.body.scrollTo(0, this.scrollLock);
        this.scrollLock = -1;
        return;
      }

    });
    var config = { attributes: true, childList: true, characterData: true };
    this.observer.observe(this.elRef.nativeElement, config);
  }
  // MutationObserver for scroll lock
  modalSearchCondition(nodes: NodeList, classFind: string): boolean {
    return Array.prototype.some.call(nodes, (node: Node) => {
      const modal = (node as HTMLElement).querySelectorAll(classFind);
      if (modal.length > 0) return true;
      return false;
    })
  }

  private webViewInit() {
    window.addEventListener('storage', this.storageChangeEvent.bind(this));
  }


  private storageChangeEvent = (data: StorageEvent) => {
    // for outside redirect
    switch (data.key) {
      case StorageEnum.NOTEDETAIL: {
        const currentDailyTabId = localStorage.getItem(StorageEnum.TABID);
        const currentTabId = sessionStorage.getItem(StorageEnum.TABID);
        if (currentDailyTabId !== currentTabId) break;
        sessionStorage.setItem(StorageEnum.FORCE_RELOAD, 'true');
        this.router.navigate([['webview', 'home', 'daily'].join('/'), { outlets: { modal: null, edit: null } }], { replaceUrl: true });
        break;
      }
      case StorageEnum.ACCESSTOKEN: {
        let newToken = this.formatStringData(data.newValue || localStorage.getItem('auth.accessToken') || '');
        if (newToken === '') return;
        const refreshToken = this.store.selectSnapshot(AuthSelectors.refreshToken) || '';
        this.store.dispatch(new SetToken(newToken, refreshToken));
        break;
      }
      case StorageEnum.LOGOUT: {
        this.store.dispatch(new Logout());
        break;
      }
      default: return;
    }
  }

  private formatStringData(rawString: string) {
    try {
      return JSON.parse(rawString);
    } catch (error) {
      return rawString;
    }
  }

  private registTabId() {
    const id = sessionStorage.getItem(StorageEnum.TABID) || null;
    if (id) return;
    const newId = guidGenerator();
    sessionStorage.setItem(StorageEnum.TABID, newId);
  }

  ngOnInit(): void {
    fromEvent(window, 'resize')
      .pipe(takeUntil(this.onDestory$), debounceTime(1000))
      .subscribe(() => {
        const height = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${height}px`);
      });
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.storageChangeEvent.bind(this));
    this.onDestory$.next();
    this.observer.disconnect();
  }
}
